import * as React from 'react'
import type { SVGProps } from 'react'
import { cn } from '../../../utils/utils'

const SvgActivity = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 32 32"
        {...props}
        className={cn('inline-block', props.className)}
    >
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 16h4l5-11 8 21 5-10h4" />
    </svg>
)
export default SvgActivity
